import * as React from 'react';
import { ANIM_STATE } from '../../constant';
import { MultiSkuStore } from '../../Store';
import './index.css';

interface IProps {
  fullDiscountToast: string;
  subTitle?: string;
}
export default class BottomToast extends React.Component<IProps, any> {
  toastRef: any;
  toastSetTimeoutId: number = 0;
  toastState: string = ANIM_STATE.END;
  store: MultiSkuStore = new MultiSkuStore();
  hiddenPosition = '-66';
  showPosition = 114 + this.store.getScreenBottom();

  componentWillUnmount(): void {
    this.handleClearTimeout();
  }

  handleClearTimeout = () => {
    if (this.toastSetTimeoutId !== 0) {
      clearTimeout(this.toastSetTimeoutId);
    }
  }

  animationTemp =(keyFrames: any, duration: number = 200) => ({
    duration: `${duration}ms`,
    iterationCount: 1,
    direction: 'normal',
    timingFunction: 'ease-in-out',
    fillMode: 'forward',
    transformOrigin: 'left top',
    delay: '0s',
    keyFrames
  })

  toastShow = () => {
    if (this.toastState !== ANIM_STATE.END) {
      return;
    }
    const keyFrames = {
      from: { bottom: this.hiddenPosition },
      to: { bottom: this.showPosition },
    };
    const animToastShow = this.animationTemp(keyFrames);
    this.toastRef.setAnimation(animToastShow, (callback) => {
      if (callback.state === 'start') {
        this.toastState = ANIM_STATE.START;
      }
      if (callback.state === 'end') {
        this.toastSetTimeoutId = setTimeout(() => {
          this.toastHidden();
        }, 3000);
      }
    });
  }

  toastHidden = () => {
    const keyFrames = {
      from: { bottom: this.showPosition },
      to: { bottom: this.hiddenPosition },
    };

    const animToastHidden = this.animationTemp(keyFrames);
    this.toastRef?.setAnimation(animToastHidden, (callback) => {
      if (callback.state === 'end') {
        this.toastState = ANIM_STATE.END;
      }
    });
  }

  render() {
    const { fullDiscountToast } = this.props;
    return (
      <view
        className="bottom-toast-mask"
        ref={(ref: any) => { this.toastRef = ref; }}
      >
        <view className="bottom-toast-mask-wrapper">
          <text content={fullDiscountToast} className="bottom-toast-title" />
        </view>
      </view>
    );
  }
}
